import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

function RoleField({ role, setRole, className }) {
  return (
    <select
      className={classNames('form-select', className)}
      required
      value={role}
      onChange={(e) => setRole(e.target.value)}
    >
      <option value="student">Student</option>
      <option value="teacher">Educator</option>
      <option value="parent">Parent/Caregiver</option>
    </select>
  );
}

RoleField.propTypes = {
  role: PropTypes.string,
  setRole: PropTypes.func.isRequired,
  className: PropTypes.string,
};

RoleField.defaultProps = {
  className: null,
  role: null,
};

export default RoleField;
